"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventStreamNodeIPCMutexLoggerWrapper = void 0;
const EventStreamEvents_1 = require("../EventStream/EventStreamEvents");
const NodeIPCMutex_1 = require("./NodeIPCMutex");
class EventStreamNodeIPCMutexLoggerWrapper extends NodeIPCMutex_1.INodeIPCMutexLogger {
    constructor(loggerEventStream, lockId) {
        super();
        this.loggerEventStream = loggerEventStream;
        this.lockId = lockId;
    }
    log(message) {
        this.loggerEventStream.post(new EventStreamEvents_1.GenericDotnetLockEvent(message, new Date().toISOString(), this.lockId, this.lockId));
    }
}
exports.EventStreamNodeIPCMutexLoggerWrapper = EventStreamNodeIPCMutexLoggerWrapper;
//# sourceMappingURL=EventStreamNodeIPCMutexWrapper.js.map